var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"splash"}},[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }